// Autogenerated file - do not edit. See generateIcons.cjs


import airplane from '$icons/airplane.svg?raw';
import airpods from '$icons/airpods.svg?raw';
import app_gift from '$icons/app.gift.svg?raw';
import apple_logo from '$icons/apple.logo.svg?raw';
import arrow_clockwise_circle from '$icons/arrow.clockwise.circle.svg?raw';
import arrow_clockwise from '$icons/arrow.clockwise.svg?raw';
import arrow_counterclockwise from '$icons/arrow.counterclockwise.svg?raw';
import arrow_down_app from '$icons/arrow.down.app.svg?raw';
import arrow_down_circle_fill from '$icons/arrow.down.circle.fill.svg?raw';
import arrow_down_circle from '$icons/arrow.down.circle.svg?raw';
import arrow_down_square_fill from '$icons/arrow.down.square.fill.svg?raw';
import arrow_down_square from '$icons/arrow.down.square.svg?raw';
import arrow_down from '$icons/arrow.down.svg?raw';
import arrow_left from '$icons/arrow.left.svg?raw';
import arrow_right from '$icons/arrow.right.svg?raw';
import arrow_trianglehead_2_clockwise_rotate_90_circle_fill from '$icons/arrow.trianglehead.2.clockwise.rotate.90.circle.fill.svg?raw';
import arrow_trianglehead_2_clockwise_rotate_90_icloud from '$icons/arrow.trianglehead.2.clockwise.rotate.90.icloud.svg?raw';
import arrow_trianglehead_bottomleft_capsulepath_clockwise from '$icons/arrow.trianglehead.bottomleft.capsulepath.clockwise.svg?raw';
import arrow_up_circle from '$icons/arrow.up.circle.svg?raw';
import arrow_up_document from '$icons/arrow.up.document.svg?raw';
import arrow_up_forward_app from '$icons/arrow.up.forward.app.svg?raw';
import arrow_up_forward_square from '$icons/arrow.up.forward.square.svg?raw';
import arrow_up_forward from '$icons/arrow.up.forward.svg?raw';
import arrow_up_right_square_fill from '$icons/arrow.up.right.square.fill.svg?raw';
import arrow_up_right from '$icons/arrow.up.right.svg?raw';
import arrow_up from '$icons/arrow.up.svg?raw';
import arrow_uturn_backward_circle from '$icons/arrow.uturn.backward.circle.svg?raw';
import arrowshape_right_circle_fill from '$icons/arrowshape.right.circle.fill.svg?raw';
import arrowshape_right_circle from '$icons/arrowshape.right.circle.svg?raw';
import arrowshape_turn_up_forward_circle_fill from '$icons/arrowshape.turn.up.forward.circle.fill.svg?raw';
import at_circle from '$icons/at.circle.svg?raw';
import audio_notes_mic from '$icons/audio.notes.mic.svg?raw';
import audio_notes from '$icons/audio.notes.svg?raw';
import badge_alpha from '$icons/badge.alpha.svg?raw';
import badge_beta from '$icons/badge.beta.svg?raw';
import bed_double_fill from '$icons/bed.double.fill.svg?raw';
import bell from '$icons/bell.svg?raw';
import bolt_circle_fill from '$icons/bolt.circle.fill.svg?raw';
import bolt_circle from '$icons/bolt.circle.svg?raw';
import bolt_fill from '$icons/bolt.fill.svg?raw';
import bolt_horizontal_circle_fill from '$icons/bolt.horizontal.circle.fill.svg?raw';
import bolt_horizontal_circle from '$icons/bolt.horizontal.circle.svg?raw';
import bolt from '$icons/bolt.svg?raw';
import book_and_sparkles from '$icons/book.and.sparkles.svg?raw';
import book_closed_fill from '$icons/book.closed.fill.svg?raw';
import book_fill from '$icons/book.fill.svg?raw';
import book_pages from '$icons/book.pages.svg?raw';
import book from '$icons/book.svg?raw';
import books_vertical from '$icons/books.vertical.svg?raw';
import brain_filled_head_profile from '$icons/brain.filled.head.profile.svg?raw';
import brain_head_profile_fill from '$icons/brain.head.profile.fill.svg?raw';
import brain_head_profile from '$icons/brain.head.profile.svg?raw';
import briefcase_fill from '$icons/briefcase.fill.svg?raw';
import briefcase from '$icons/briefcase.svg?raw';
import calendar_and_person from '$icons/calendar.and.person.svg?raw';
import calendar_badge_plus from '$icons/calendar.badge.plus.svg?raw';
import calendar_circle from '$icons/calendar.circle.svg?raw';
import calendar from '$icons/calendar.svg?raw';
import camera_fill from '$icons/camera.fill.svg?raw';
import camera_filters from '$icons/camera.filters.svg?raw';
import captions_bubble from '$icons/captions.bubble.svg?raw';
import cart_fill from '$icons/cart.fill.svg?raw';
import case_fill from '$icons/case.fill.svg?raw';
import chart_bar from '$icons/chart.bar.svg?raw';
import chart_pie_fill from '$icons/chart.pie.fill.svg?raw';
import checklist from '$icons/checklist.svg?raw';
import checkmark_circle_fill from '$icons/checkmark.circle.fill.svg?raw';
import checkmark_circle from '$icons/checkmark.circle.svg?raw';
import checkmark_seal_fill from '$icons/checkmark.seal.fill.svg?raw';
import checkmark_shield_fill from '$icons/checkmark.shield.fill.svg?raw';
import checkmark_shield from '$icons/checkmark.shield.svg?raw';
import checkmark_square_fill from '$icons/checkmark.square.fill.svg?raw';
import checkmark_square from '$icons/checkmark.square.svg?raw';
import checkmark from '$icons/checkmark.svg?raw';
import chevron_left from '$icons/chevron.left.svg?raw';
import chevron_right_2 from '$icons/chevron.right.2.svg?raw';
import chevron_right from '$icons/chevron.right.svg?raw';
import circle_dotted from '$icons/circle.dotted.svg?raw';
import circle_fill from '$icons/circle.fill.svg?raw';
import circle_grid_cross from '$icons/circle.grid.cross.svg?raw';
import circle_hexagonpath from '$icons/circle.hexagonpath.svg?raw';
import circle_lefthalf_striped_horizontal from '$icons/circle.lefthalf.striped.horizontal.svg?raw';
import clock_arrow_trianglehead_2_counterclockwise_rotate_90 from '$icons/clock.arrow.trianglehead.2.counterclockwise.rotate.90.svg?raw';
import clock from '$icons/clock.svg?raw';
import creditcard_fill from '$icons/creditcard.fill.svg?raw';
import creditcard from '$icons/creditcard.svg?raw';
import database_plus from '$icons/database.plus.svg?raw';
import desktopcomputer_and_macbook from '$icons/desktopcomputer.and.macbook.svg?raw';
import document_badge_plus from '$icons/document.badge.plus.svg?raw';
import dollarsign_circle_fill from '$icons/dollarsign.circle.fill.svg?raw';
import ellipsis_circle_fill from '$icons/ellipsis.circle.fill.svg?raw';
import ellipsis from '$icons/ellipsis.svg?raw';
import envelope_fill from '$icons/envelope.fill.svg?raw';
import envelope from '$icons/envelope.svg?raw';
import exclamationmark_icloud from '$icons/exclamationmark.icloud.svg?raw';
import exclamationmark from '$icons/exclamationmark.svg?raw';
import exclamationmark_triangle_fill from '$icons/exclamationmark.triangle.fill.svg?raw';
import externaldrive from '$icons/externaldrive.svg?raw';
import eyeglasses from '$icons/eyeglasses.svg?raw';
import fb_logo from '$icons/fb.logo.svg?raw';
import feather from '$icons/feather.svg?raw';
import figure_walk_circle_fill from '$icons/figure.walk.circle.fill.svg?raw';
import film_fill from '$icons/film.fill.svg?raw';
import flag_circle_fill from '$icons/flag.circle.fill.svg?raw';
import flag_circle from '$icons/flag.circle.svg?raw';
import flag_fill from '$icons/flag.fill.svg?raw';
import flag from '$icons/flag.svg?raw';
import flame_fill from '$icons/flame.fill.svg?raw';
import folder_fill from '$icons/folder.fill.svg?raw';
import fork_knife_circle_fill from '$icons/fork.knife.circle.fill.svg?raw';
import fork_knife from '$icons/fork.knife.svg?raw';
import gamecontroller_fill from '$icons/gamecontroller.fill.svg?raw';
import gearshape from '$icons/gearshape.svg?raw';
import globe_americas_fill from '$icons/globe.americas.fill.svg?raw';
import globe from '$icons/globe.svg?raw';
import gmail_dotmatrix from '$icons/gmail.dotmatrix.svg?raw';
import gmail from '$icons/gmail.svg?raw';
import google_calendar from '$icons/google.calendar.svg?raw';
import google_drive_logo from '$icons/google.drive.logo.svg?raw';
import google_logo from '$icons/google.logo.svg?raw';
import graduationcap_fill from '$icons/graduationcap.fill.svg?raw';
import graduationcap from '$icons/graduationcap.svg?raw';
import heart_fill from '$icons/heart.fill.svg?raw';
import hexagon from '$icons/hexagon.svg?raw';
import house_fill from '$icons/house.fill.svg?raw';
import house from '$icons/house.svg?raw';
import i_circle_fill from '$icons/i.circle.fill.svg?raw';
import icloud_and_arrow_up_fill from '$icons/icloud.and.arrow.up.fill.svg?raw';
import icloud_and_arrow_up from '$icons/icloud.and.arrow.up.svg?raw';
import icloud from '$icons/icloud.svg?raw';
import info_circle_fill from '$icons/info.circle.fill.svg?raw';
import inset_filled_square from '$icons/inset.filled.square.svg?raw';
import instagram_logo from '$icons/instagram.logo.svg?raw';
import lamp_desk_fill from '$icons/lamp.desk.fill.svg?raw';
import lamp_desk from '$icons/lamp.desk.svg?raw';
import leaf_fill from '$icons/leaf.fill.svg?raw';
import lifepreserver_fill from '$icons/lifepreserver.fill.svg?raw';
import lightbulb_fill from '$icons/lightbulb.fill.svg?raw';
import lightbulb from '$icons/lightbulb.svg?raw';
import line_3_horizontal from '$icons/line.3.horizontal.svg?raw';
import linear_logo from '$icons/linear.logo.svg?raw';
import link from '$icons/link.svg?raw';
import linkedin_logo from '$icons/linkedin.logo.svg?raw';
import llm_anthropic from '$icons/llm.anthropic.svg?raw';
import llm_google from '$icons/llm.google.svg?raw';
import llm_meta from '$icons/llm.meta.svg?raw';
import llm_openai from '$icons/llm.openai.svg?raw';
import lock_icloud_fill from '$icons/lock.icloud.fill.svg?raw';
import long_text_page_and_pencil_fill from '$icons/long.text.page.and.pencil.fill.svg?raw';
import long_text_page_and_quill from '$icons/long.text.page.and.quill.svg?raw';
import magnifyingglass_dotmatrix from '$icons/magnifyingglass.dotmatrix.svg?raw';
import magnifyingglass from '$icons/magnifyingglass.svg?raw';
import map from '$icons/map.svg?raw';
import mappin_circle_fill from '$icons/mappin.circle.fill.svg?raw';
import medal from '$icons/medal.svg?raw';
import megaphone_fill from '$icons/megaphone.fill.svg?raw';
import microphone_dotmatrix from '$icons/microphone.dotmatrix.svg?raw';
import microphone_fill from '$icons/microphone.fill.svg?raw';
import microphone from '$icons/microphone.svg?raw';
import music_note_list from '$icons/music.note.list.svg?raw';
import network from '$icons/network.svg?raw';
import note_text_badge_plus from '$icons/note.text.badge.plus.svg?raw';
import note_text from '$icons/note.text.svg?raw';
import notepad_and_microphone from '$icons/notepad.and.microphone.svg?raw';
import notepad_mic_pencil from '$icons/notepad.mic.pencil.svg?raw';
import orb_blue from '$icons/orb.blue.svg?raw';
import orb_new from '$icons/orb.new.svg?raw';
import orb_fuchsia from '$icons/orb_fuchsia.svg?raw';
import orb_gold from '$icons/orb_gold.svg?raw';
import orb_purple from '$icons/orb_purple.svg?raw';
import orb_teal from '$icons/orb_teal.svg?raw';
import orbs_cluster from '$icons/orbs.cluster.svg?raw';
import os_windows from '$icons/os.windows.svg?raw';
import paintpalette_fill from '$icons/paintpalette.fill.svg?raw';
import paperairplane_dotmatrix from '$icons/paperairplane.dotmatrix.svg?raw';
import paperclip from '$icons/paperclip.svg?raw';
import paperplane from '$icons/paperplane.svg?raw';
import pawprint_fill from '$icons/pawprint.fill.svg?raw';
import pencil_and_outline from '$icons/pencil.and.outline.svg?raw';
import pencil_dotmatrix from '$icons/pencil.dotmatrix.svg?raw';
import pencil_line from '$icons/pencil.line.svg?raw';
import person_2_circle from '$icons/person.2.circle.svg?raw';
import person_3_fill from '$icons/person.3.fill.svg?raw';
import person_3 from '$icons/person.3.svg?raw';
import person_circle from '$icons/person.circle.svg?raw';
import person_crop_circle from '$icons/person.crop.circle.svg?raw';
import person from '$icons/person.svg?raw';
import pin_fill from '$icons/pin.fill.svg?raw';
import play_fill from '$icons/play.fill.svg?raw';
import plus from '$icons/plus.svg?raw';
import point_3_filled_connected_trianglepath_dotted from '$icons/point.3.filled.connected.trianglepath.dotted.svg?raw';
import popup_top_triangle from '$icons/popup.top.triangle.svg?raw';
import puzzlepiece_extension from '$icons/puzzlepiece.extension.svg?raw';
import questionmark_bubble from '$icons/questionmark.bubble.svg?raw';
import questionmark_circle_fill from '$icons/questionmark.circle.fill.svg?raw';
import questionmark_circle from '$icons/questionmark.circle.svg?raw';
import quill from '$icons/quill.svg?raw';
import reader from '$icons/reader.svg?raw';
import reading from '$icons/reading.svg?raw';
import safari from '$icons/safari.svg?raw';
import sidebar_left from '$icons/sidebar.left.svg?raw';
import six_dots from '$icons/six.dots.svg?raw';
import slider_vertical_3 from '$icons/slider.vertical.3.svg?raw';
import sparkles_dotmatrix from '$icons/sparkles.dotmatrix.svg?raw';
import sparkles_square_filled_on_square from '$icons/sparkles.square.filled.on.square.svg?raw';
import sparkles from '$icons/sparkles.svg?raw';
import square_and_arrow_up from '$icons/square.and.arrow.up.svg?raw';
import square_and_pencil from '$icons/square.and.pencil.svg?raw';
import square_mic_pencil from '$icons/square.mic.pencil.svg?raw';
import square_on_square from '$icons/square.on.square.svg?raw';
import star_circle_fill from '$icons/star.circle.fill.svg?raw';
import star_circle from '$icons/star.circle.svg?raw';
import star from '$icons/star.svg?raw';
import stop_circle_fill from '$icons/stop.circle.fill.svg?raw';
import stop_circle from '$icons/stop.circle.svg?raw';
import suit_heart_fill from '$icons/suit.heart.fill.svg?raw';
import sun_min from '$icons/sun.min.svg?raw';
import target from '$icons/target.svg?raw';
import text_bubble_badge_clock from '$icons/text.bubble.badge.clock.svg?raw';
import text_bubble from '$icons/text.bubble.svg?raw';
import text_document_fill from '$icons/text.document.fill.svg?raw';
import text_document from '$icons/text.document.svg?raw';
import text_justify_left from '$icons/text.justify.left.svg?raw';
import trash from '$icons/trash.svg?raw';
import twitter_x_logo from '$icons/twitter.x.logo.svg?raw';
import video_circle from '$icons/video.circle.svg?raw';
import video from '$icons/video.svg?raw';
import viewfinder_circle_fill from '$icons/viewfinder.circle.fill.svg?raw';
import viewfinder_circle from '$icons/viewfinder.circle.svg?raw';
import wand_and_sparkles from '$icons/wand.and.sparkles.svg?raw';
import watch_dotmatrix from '$icons/watch.dotmatrix.svg?raw';
import waveform_circle from '$icons/waveform.circle.svg?raw';
import waveform from '$icons/waveform.svg?raw';
import wrench_and_screwdriver_fill from '$icons/wrench.and.screwdriver.fill.svg?raw';
import wrench_and_screwdriver from '$icons/wrench.and.screwdriver.svg?raw';
import xmark_bin_fill from '$icons/xmark.bin.fill.svg?raw';
import xmark_circle_fill from '$icons/xmark.circle.fill.svg?raw';
import youtube_logo from '$icons/youtube.logo.svg?raw';

export const icons = {
  "airplane": airplane,
  "airpods": airpods,
  "app_gift": app_gift,
  "apple_logo": apple_logo,
  "arrow_clockwise_circle": arrow_clockwise_circle,
  "arrow_clockwise": arrow_clockwise,
  "arrow_counterclockwise": arrow_counterclockwise,
  "arrow_down_app": arrow_down_app,
  "arrow_down_circle_fill": arrow_down_circle_fill,
  "arrow_down_circle": arrow_down_circle,
  "arrow_down_square_fill": arrow_down_square_fill,
  "arrow_down_square": arrow_down_square,
  "arrow_down": arrow_down,
  "arrow_left": arrow_left,
  "arrow_right": arrow_right,
  "arrow_trianglehead_2_clockwise_rotate_90_circle_fill": arrow_trianglehead_2_clockwise_rotate_90_circle_fill,
  "arrow_trianglehead_2_clockwise_rotate_90_icloud": arrow_trianglehead_2_clockwise_rotate_90_icloud,
  "arrow_trianglehead_bottomleft_capsulepath_clockwise": arrow_trianglehead_bottomleft_capsulepath_clockwise,
  "arrow_up_circle": arrow_up_circle,
  "arrow_up_document": arrow_up_document,
  "arrow_up_forward_app": arrow_up_forward_app,
  "arrow_up_forward_square": arrow_up_forward_square,
  "arrow_up_forward": arrow_up_forward,
  "arrow_up_right_square_fill": arrow_up_right_square_fill,
  "arrow_up_right": arrow_up_right,
  "arrow_up": arrow_up,
  "arrow_uturn_backward_circle": arrow_uturn_backward_circle,
  "arrowshape_right_circle_fill": arrowshape_right_circle_fill,
  "arrowshape_right_circle": arrowshape_right_circle,
  "arrowshape_turn_up_forward_circle_fill": arrowshape_turn_up_forward_circle_fill,
  "at_circle": at_circle,
  "audio_notes_mic": audio_notes_mic,
  "audio_notes": audio_notes,
  "badge_alpha": badge_alpha,
  "badge_beta": badge_beta,
  "bed_double_fill": bed_double_fill,
  "bell": bell,
  "bolt_circle_fill": bolt_circle_fill,
  "bolt_circle": bolt_circle,
  "bolt_fill": bolt_fill,
  "bolt_horizontal_circle_fill": bolt_horizontal_circle_fill,
  "bolt_horizontal_circle": bolt_horizontal_circle,
  "bolt": bolt,
  "book_and_sparkles": book_and_sparkles,
  "book_closed_fill": book_closed_fill,
  "book_fill": book_fill,
  "book_pages": book_pages,
  "book": book,
  "books_vertical": books_vertical,
  "brain_filled_head_profile": brain_filled_head_profile,
  "brain_head_profile_fill": brain_head_profile_fill,
  "brain_head_profile": brain_head_profile,
  "briefcase_fill": briefcase_fill,
  "briefcase": briefcase,
  "calendar_and_person": calendar_and_person,
  "calendar_badge_plus": calendar_badge_plus,
  "calendar_circle": calendar_circle,
  "calendar": calendar,
  "camera_fill": camera_fill,
  "camera_filters": camera_filters,
  "captions_bubble": captions_bubble,
  "cart_fill": cart_fill,
  "case_fill": case_fill,
  "chart_bar": chart_bar,
  "chart_pie_fill": chart_pie_fill,
  "checklist": checklist,
  "checkmark_circle_fill": checkmark_circle_fill,
  "checkmark_circle": checkmark_circle,
  "checkmark_seal_fill": checkmark_seal_fill,
  "checkmark_shield_fill": checkmark_shield_fill,
  "checkmark_shield": checkmark_shield,
  "checkmark_square_fill": checkmark_square_fill,
  "checkmark_square": checkmark_square,
  "checkmark": checkmark,
  "chevron_left": chevron_left,
  "chevron_right_2": chevron_right_2,
  "chevron_right": chevron_right,
  "circle_dotted": circle_dotted,
  "circle_fill": circle_fill,
  "circle_grid_cross": circle_grid_cross,
  "circle_hexagonpath": circle_hexagonpath,
  "circle_lefthalf_striped_horizontal": circle_lefthalf_striped_horizontal,
  "clock_arrow_trianglehead_2_counterclockwise_rotate_90": clock_arrow_trianglehead_2_counterclockwise_rotate_90,
  "clock": clock,
  "creditcard_fill": creditcard_fill,
  "creditcard": creditcard,
  "database_plus": database_plus,
  "desktopcomputer_and_macbook": desktopcomputer_and_macbook,
  "document_badge_plus": document_badge_plus,
  "dollarsign_circle_fill": dollarsign_circle_fill,
  "ellipsis_circle_fill": ellipsis_circle_fill,
  "ellipsis": ellipsis,
  "envelope_fill": envelope_fill,
  "envelope": envelope,
  "exclamationmark_icloud": exclamationmark_icloud,
  "exclamationmark": exclamationmark,
  "exclamationmark_triangle_fill": exclamationmark_triangle_fill,
  "externaldrive": externaldrive,
  "eyeglasses": eyeglasses,
  "fb_logo": fb_logo,
  "feather": feather,
  "figure_walk_circle_fill": figure_walk_circle_fill,
  "film_fill": film_fill,
  "flag_circle_fill": flag_circle_fill,
  "flag_circle": flag_circle,
  "flag_fill": flag_fill,
  "flag": flag,
  "flame_fill": flame_fill,
  "folder_fill": folder_fill,
  "fork_knife_circle_fill": fork_knife_circle_fill,
  "fork_knife": fork_knife,
  "gamecontroller_fill": gamecontroller_fill,
  "gearshape": gearshape,
  "globe_americas_fill": globe_americas_fill,
  "globe": globe,
  "gmail_dotmatrix": gmail_dotmatrix,
  "gmail": gmail,
  "google_calendar": google_calendar,
  "google_drive_logo": google_drive_logo,
  "google_logo": google_logo,
  "graduationcap_fill": graduationcap_fill,
  "graduationcap": graduationcap,
  "heart_fill": heart_fill,
  "hexagon": hexagon,
  "house_fill": house_fill,
  "house": house,
  "i_circle_fill": i_circle_fill,
  "icloud_and_arrow_up_fill": icloud_and_arrow_up_fill,
  "icloud_and_arrow_up": icloud_and_arrow_up,
  "icloud": icloud,
  "info_circle_fill": info_circle_fill,
  "inset_filled_square": inset_filled_square,
  "instagram_logo": instagram_logo,
  "lamp_desk_fill": lamp_desk_fill,
  "lamp_desk": lamp_desk,
  "leaf_fill": leaf_fill,
  "lifepreserver_fill": lifepreserver_fill,
  "lightbulb_fill": lightbulb_fill,
  "lightbulb": lightbulb,
  "line_3_horizontal": line_3_horizontal,
  "linear_logo": linear_logo,
  "link": link,
  "linkedin_logo": linkedin_logo,
  "llm_anthropic": llm_anthropic,
  "llm_google": llm_google,
  "llm_meta": llm_meta,
  "llm_openai": llm_openai,
  "lock_icloud_fill": lock_icloud_fill,
  "long_text_page_and_pencil_fill": long_text_page_and_pencil_fill,
  "long_text_page_and_quill": long_text_page_and_quill,
  "magnifyingglass_dotmatrix": magnifyingglass_dotmatrix,
  "magnifyingglass": magnifyingglass,
  "map": map,
  "mappin_circle_fill": mappin_circle_fill,
  "medal": medal,
  "megaphone_fill": megaphone_fill,
  "microphone_dotmatrix": microphone_dotmatrix,
  "microphone_fill": microphone_fill,
  "microphone": microphone,
  "music_note_list": music_note_list,
  "network": network,
  "note_text_badge_plus": note_text_badge_plus,
  "note_text": note_text,
  "notepad_and_microphone": notepad_and_microphone,
  "notepad_mic_pencil": notepad_mic_pencil,
  "orb_blue": orb_blue,
  "orb_new": orb_new,
  "orb_fuchsia": orb_fuchsia,
  "orb_gold": orb_gold,
  "orb_purple": orb_purple,
  "orb_teal": orb_teal,
  "orbs_cluster": orbs_cluster,
  "os_windows": os_windows,
  "paintpalette_fill": paintpalette_fill,
  "paperairplane_dotmatrix": paperairplane_dotmatrix,
  "paperclip": paperclip,
  "paperplane": paperplane,
  "pawprint_fill": pawprint_fill,
  "pencil_and_outline": pencil_and_outline,
  "pencil_dotmatrix": pencil_dotmatrix,
  "pencil_line": pencil_line,
  "person_2_circle": person_2_circle,
  "person_3_fill": person_3_fill,
  "person_3": person_3,
  "person_circle": person_circle,
  "person_crop_circle": person_crop_circle,
  "person": person,
  "pin_fill": pin_fill,
  "play_fill": play_fill,
  "plus": plus,
  "point_3_filled_connected_trianglepath_dotted": point_3_filled_connected_trianglepath_dotted,
  "popup_top_triangle": popup_top_triangle,
  "puzzlepiece_extension": puzzlepiece_extension,
  "questionmark_bubble": questionmark_bubble,
  "questionmark_circle_fill": questionmark_circle_fill,
  "questionmark_circle": questionmark_circle,
  "quill": quill,
  "reader": reader,
  "reading": reading,
  "safari": safari,
  "sidebar_left": sidebar_left,
  "six_dots": six_dots,
  "slider_vertical_3": slider_vertical_3,
  "sparkles_dotmatrix": sparkles_dotmatrix,
  "sparkles_square_filled_on_square": sparkles_square_filled_on_square,
  "sparkles": sparkles,
  "square_and_arrow_up": square_and_arrow_up,
  "square_and_pencil": square_and_pencil,
  "square_mic_pencil": square_mic_pencil,
  "square_on_square": square_on_square,
  "star_circle_fill": star_circle_fill,
  "star_circle": star_circle,
  "star": star,
  "stop_circle_fill": stop_circle_fill,
  "stop_circle": stop_circle,
  "suit_heart_fill": suit_heart_fill,
  "sun_min": sun_min,
  "target": target,
  "text_bubble_badge_clock": text_bubble_badge_clock,
  "text_bubble": text_bubble,
  "text_document_fill": text_document_fill,
  "text_document": text_document,
  "text_justify_left": text_justify_left,
  "trash": trash,
  "twitter_x_logo": twitter_x_logo,
  "video_circle": video_circle,
  "video": video,
  "viewfinder_circle_fill": viewfinder_circle_fill,
  "viewfinder_circle": viewfinder_circle,
  "wand_and_sparkles": wand_and_sparkles,
  "watch_dotmatrix": watch_dotmatrix,
  "waveform_circle": waveform_circle,
  "waveform": waveform,
  "wrench_and_screwdriver_fill": wrench_and_screwdriver_fill,
  "wrench_and_screwdriver": wrench_and_screwdriver,
  "xmark_bin_fill": xmark_bin_fill,
  "xmark_circle_fill": xmark_circle_fill,
  "youtube_logo": youtube_logo
};
export type IconValues = "airplane" | "airpods" | "app_gift" | "apple_logo" | "arrow_clockwise_circle" | "arrow_clockwise" | "arrow_counterclockwise" | "arrow_down_app" | "arrow_down_circle_fill" | "arrow_down_circle" | "arrow_down_square_fill" | "arrow_down_square" | "arrow_down" | "arrow_left" | "arrow_right" | "arrow_trianglehead_2_clockwise_rotate_90_circle_fill" | "arrow_trianglehead_2_clockwise_rotate_90_icloud" | "arrow_trianglehead_bottomleft_capsulepath_clockwise" | "arrow_up_circle" | "arrow_up_document" | "arrow_up_forward_app" | "arrow_up_forward_square" | "arrow_up_forward" | "arrow_up_right_square_fill" | "arrow_up_right" | "arrow_up" | "arrow_uturn_backward_circle" | "arrowshape_right_circle_fill" | "arrowshape_right_circle" | "arrowshape_turn_up_forward_circle_fill" | "at_circle" | "audio_notes_mic" | "audio_notes" | "badge_alpha" | "badge_beta" | "bed_double_fill" | "bell" | "bolt_circle_fill" | "bolt_circle" | "bolt_fill" | "bolt_horizontal_circle_fill" | "bolt_horizontal_circle" | "bolt" | "book_and_sparkles" | "book_closed_fill" | "book_fill" | "book_pages" | "book" | "books_vertical" | "brain_filled_head_profile" | "brain_head_profile_fill" | "brain_head_profile" | "briefcase_fill" | "briefcase" | "calendar_and_person" | "calendar_badge_plus" | "calendar_circle" | "calendar" | "camera_fill" | "camera_filters" | "captions_bubble" | "cart_fill" | "case_fill" | "chart_bar" | "chart_pie_fill" | "checklist" | "checkmark_circle_fill" | "checkmark_circle" | "checkmark_seal_fill" | "checkmark_shield_fill" | "checkmark_shield" | "checkmark_square_fill" | "checkmark_square" | "checkmark" | "chevron_left" | "chevron_right_2" | "chevron_right" | "circle_dotted" | "circle_fill" | "circle_grid_cross" | "circle_hexagonpath" | "circle_lefthalf_striped_horizontal" | "clock_arrow_trianglehead_2_counterclockwise_rotate_90" | "clock" | "creditcard_fill" | "creditcard" | "database_plus" | "desktopcomputer_and_macbook" | "document_badge_plus" | "dollarsign_circle_fill" | "ellipsis_circle_fill" | "ellipsis" | "envelope_fill" | "envelope" | "exclamationmark_icloud" | "exclamationmark" | "exclamationmark_triangle_fill" | "externaldrive" | "eyeglasses" | "fb_logo" | "feather" | "figure_walk_circle_fill" | "film_fill" | "flag_circle_fill" | "flag_circle" | "flag_fill" | "flag" | "flame_fill" | "folder_fill" | "fork_knife_circle_fill" | "fork_knife" | "gamecontroller_fill" | "gearshape" | "globe_americas_fill" | "globe" | "gmail_dotmatrix" | "gmail" | "google_calendar" | "google_drive_logo" | "google_logo" | "graduationcap_fill" | "graduationcap" | "heart_fill" | "hexagon" | "house_fill" | "house" | "i_circle_fill" | "icloud_and_arrow_up_fill" | "icloud_and_arrow_up" | "icloud" | "info_circle_fill" | "inset_filled_square" | "instagram_logo" | "lamp_desk_fill" | "lamp_desk" | "leaf_fill" | "lifepreserver_fill" | "lightbulb_fill" | "lightbulb" | "line_3_horizontal" | "linear_logo" | "link" | "linkedin_logo" | "llm_anthropic" | "llm_google" | "llm_meta" | "llm_openai" | "lock_icloud_fill" | "long_text_page_and_pencil_fill" | "long_text_page_and_quill" | "magnifyingglass_dotmatrix" | "magnifyingglass" | "map" | "mappin_circle_fill" | "medal" | "megaphone_fill" | "microphone_dotmatrix" | "microphone_fill" | "microphone" | "music_note_list" | "network" | "note_text_badge_plus" | "note_text" | "notepad_and_microphone" | "notepad_mic_pencil" | "orb_blue" | "orb_new" | "orb_fuchsia" | "orb_gold" | "orb_purple" | "orb_teal" | "orbs_cluster" | "os_windows" | "paintpalette_fill" | "paperairplane_dotmatrix" | "paperclip" | "paperplane" | "pawprint_fill" | "pencil_and_outline" | "pencil_dotmatrix" | "pencil_line" | "person_2_circle" | "person_3_fill" | "person_3" | "person_circle" | "person_crop_circle" | "person" | "pin_fill" | "play_fill" | "plus" | "point_3_filled_connected_trianglepath_dotted" | "popup_top_triangle" | "puzzlepiece_extension" | "questionmark_bubble" | "questionmark_circle_fill" | "questionmark_circle" | "quill" | "reader" | "reading" | "safari" | "sidebar_left" | "six_dots" | "slider_vertical_3" | "sparkles_dotmatrix" | "sparkles_square_filled_on_square" | "sparkles" | "square_and_arrow_up" | "square_and_pencil" | "square_mic_pencil" | "square_on_square" | "star_circle_fill" | "star_circle" | "star" | "stop_circle_fill" | "stop_circle" | "suit_heart_fill" | "sun_min" | "target" | "text_bubble_badge_clock" | "text_bubble" | "text_document_fill" | "text_document" | "text_justify_left" | "trash" | "twitter_x_logo" | "video_circle" | "video" | "viewfinder_circle_fill" | "viewfinder_circle" | "wand_and_sparkles" | "watch_dotmatrix" | "waveform_circle" | "waveform" | "wrench_and_screwdriver_fill" | "wrench_and_screwdriver" | "xmark_bin_fill" | "xmark_circle_fill" | "youtube_logo";
